/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Role, RoleFromJSON, RoleToJSON } from '../models'
import * as runtime from '../runtime'

export interface CreateRoleRequest extends runtime.BaseRequestParameters {
  body: Role
}

export interface DeleteRoleRequest extends runtime.BaseRequestParameters {
  roleKey: number
}

export interface UpdateRoleRequest extends runtime.BaseRequestParameters {
  body: Role
}

/**
 * RolesApi - interface
 *
 * @export
 * @interface RolesApiInterface
 */
export interface RolesApiInterface {
  /**
   * A user with an active grant to create a Role is able to create a new role. A role is group of grants i.e. a Role of Support Representative can create / edit / view their team\'s communities.
   * @summary Create a new role with grants
   * @param {Role} role Describes a named collection of permissions that the role grants to users holding the role. Each permission has an associated scope to which the grant applies (globally, or restricted by the reporting hierarchy to those transitively reporting to the current user with regard to the role).  The set of roles is _not_ fixed; roles can come, go, and be renamed at any time. A user gains permissions solely by being granted a role.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApiInterface
   */
  createRoleRaw(
    requestParameters: CreateRoleRequest
  ): Promise<runtime.ApiResponse<Role>>

  /**
   * A user with an active grant to create a Role is able to create a new role. A role is group of grants i.e. a Role of Support Representative can create / edit / view their team\'s communities.
   * Create a new role with grants
   */
  createRole(requestParameters: CreateRoleRequest): Promise<Role>

  /**
   * A user with an active grant to DELETE a Role is able to delete the role along with all its grants.
   * @summary Delete a role along with the grants.
   * @param {number} roleKey The &#x60;roleKey&#x60; is the unique identifier for a Role.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApiInterface
   */
  deleteRoleRaw(
    requestParameters: DeleteRoleRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * A user with an active grant to DELETE a Role is able to delete the role along with all its grants.
   * Delete a role along with the grants.
   */
  deleteRole(requestParameters: DeleteRoleRequest): Promise<void>

  /**
   * A user with an active grant to update a Role is able to modify the grants on the existing role.
   * @summary Update the grants on an existing role.
   * @param {Role} role Describes a named collection of permissions that the role grants to users holding the role. Each permission has an associated scope to which the grant applies (globally, or restricted by the reporting hierarchy to those transitively reporting to the current user with regard to the role).  The set of roles is _not_ fixed; roles can come, go, and be renamed at any time. A user gains permissions solely by being granted a role.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolesApiInterface
   */
  updateRoleRaw(
    requestParameters: UpdateRoleRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * A user with an active grant to update a Role is able to modify the grants on the existing role.
   * Update the grants on an existing role.
   */
  updateRole(requestParameters: UpdateRoleRequest): Promise<void>
}

/**
 *
 */
export class RolesApi extends runtime.BaseAPI implements RolesApiInterface {
  /**
   * A user with an active grant to create a Role is able to create a new role. A role is group of grants i.e. a Role of Support Representative can create / edit / view their team\'s communities.
   * Create a new role with grants
   */
  async createRoleRaw(
    requestParameters: CreateRoleRequest
  ): Promise<runtime.ApiResponse<Role>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createRole.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/roles`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: RoleToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RoleFromJSON(jsonValue)
    )
  }

  /**
   * A user with an active grant to create a Role is able to create a new role. A role is group of grants i.e. a Role of Support Representative can create / edit / view their team\'s communities.
   * Create a new role with grants
   */
  async createRole(requestParameters: CreateRoleRequest): Promise<Role> {
    const response = await this.createRoleRaw(requestParameters)
    return await response.value()
  }

  /**
   * A user with an active grant to DELETE a Role is able to delete the role along with all its grants.
   * Delete a role along with the grants.
   */
  async deleteRoleRaw(
    requestParameters: DeleteRoleRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.roleKey === null ||
      requestParameters.roleKey === undefined
    ) {
      throw new runtime.RequiredError(
        'roleKey',
        'Required parameter requestParameters.roleKey was null or undefined when calling deleteRole.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/roles/{roleKey}`.replace(
        `{${'roleKey'}}`,
        encodeURIComponent(String(requestParameters.roleKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * A user with an active grant to DELETE a Role is able to delete the role along with all its grants.
   * Delete a role along with the grants.
   */
  async deleteRole(requestParameters: DeleteRoleRequest): Promise<void> {
    await this.deleteRoleRaw(requestParameters)
  }

  /**
   * A user with an active grant to update a Role is able to modify the grants on the existing role.
   * Update the grants on an existing role.
   */
  async updateRoleRaw(
    requestParameters: UpdateRoleRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updateRole.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/roles`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: RoleToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * A user with an active grant to update a Role is able to modify the grants on the existing role.
   * Update the grants on an existing role.
   */
  async updateRole(requestParameters: UpdateRoleRequest): Promise<void> {
    await this.updateRoleRaw(requestParameters)
  }
}
